import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  formatDate,
  formatDateForInput,
  getDateFormatExample,
} from '../../utils/dateFormat';
import './DatePicker.css';

/**
 * Компонент выбора даты с поддержкой локализации
 * Формат отображения зависит от локали пользователя:
 * - Для болгарского и европейских языков: DD/MM/YYYY
 * - Для английского: MM/DD/YYYY
 * - Для турецкого: DD.MM.YYYY
 */
function DatePicker({ value, onChange, name, label, required = false, ...props }) {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;

  // Форматирование даты для отображения
  const formatDisplayDate = (dateString) => {
    return formatDate(dateString, currentLang);
  };

  // Нормализуем значение в YYYY-MM-DD — формат, ожидаемый нативным
  // input[type=date]. Любой другой формат (полная ISO-метка из Firestore,
  // дата при репосте и т.д.) браузер молча отклоняет: календарь не открывается,
  // а при ручном вводе часть даты (например, месяц) «исчезает».
  const inputValue = formatDateForInput(value);

  // Обработка изменения даты
  const handleChange = (e) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  // Получить пример формата для текущей локали
  const formatExample = getDateFormatExample(currentLang);

  return (
    <div className="datePicker">
      {label && (
        <label htmlFor={name} className="datePickerLabel">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <input
        id={name}
        name={name}
        type="date"
        value={inputValue}
        onChange={handleChange}
        className="datePickerInput"
        required={required}
        {...props}
      />
      {inputValue && (
        <div className="datePickerDisplay">{formatDisplayDate(inputValue)}</div>
      )}
      {!inputValue && (
        <div className="datePickerHint">
          {t('createAd.dateFormat', { format: formatExample })}
        </div>
      )}
    </div>
  );
}

export default DatePicker;